import Flatpickr from "stimulus-flatpickr";

import "flatpickr/dist/themes/dark.css";

import { english } from "flatpickr/dist/l10n/default.js";

// create a new Stimulus controller by extending stimulus-flatpickr wrapper controller
export default class extends Flatpickr {  
  connect() {

    //define locale and global flatpickr settings for all datepickers
    this.config = {
      locale: english,
      theme: 'dark',
      dateFormat: this.element.getAttribute('data-flatpickr-date-format') || 'Y/m/d',
      altInput: true,
      altFormat: this.element.getAttribute('data-flatpickr-alt-format') || 'd/m/Y',
      enableTime: this.element.hasAttribute('data-flatpickr-enable-time'),
      allowInput: true,
      required: this.element.hasAttribute('required')
    };

    super.connect();
  }

  get value() {
    this.element.value;
  }

  // Could be common functions moved into base class
  get form() {
    return this.element.closest('form');
  }
}
